import React, { useEffect, useState } from "react";
import qs from "query-string";

import Widget from "app/components/widget/Widget";
import PageWrapper from "app/components/page-wrapper/PageWrapper";
import RechargePlans from "app/components/recharge-plans/RechargePlans";
import { GET_RECHARGE_PLANS, RECHARGE_PLANS_BASE } from "app/api/ApiEndpoints";
import { useGet } from "app/services/http-service";
import { useMutation } from "react-query";
import { StoreContext } from "app/context/Store";

export default function RechargePlanByCircleOperator(props) {
  const authToken = localStorage.getItem("tspAuthToken");
  const [visibleTab, setVisibleTab] = React.useState("1");
  const context = React.useContext(StoreContext);
  const [step, setStep] = React.useState(3);
  const [operatorId , setOperatorId] =React.useState(props?.match?.params?.operator);
  const [circleId, setCircleId] = React.useState(props?.match?.params?.circle);
  const {
    mutate: rechargePlansMutation,
    data: rechargePlansData,
    isSuccess: fetchedRechargePlan,
  } = useMutation((data) => useGet(data));

  const {
    mutate: rechargePlanTypesMutation,
  } = useMutation((data) => useGet(data), {
    onSuccess: (resp) => {
      setTabTypes(resp.payload.map((type, index) => {
        return { id: index, tabTitle: type, tabContent: <></> };
      }));
    }
  });

  useEffect(()=> {
    if(operatorId && circleId) {
      rechargePlanTypesMutation({
        url: `${RECHARGE_PLANS_BASE}/display-type?operatorId=${operatorId}&circleId=${circleId}`,
        token: authToken,
      });
    }
  }, [operatorId, circleId]);

  const changeStep = (val) => {
    setStep(val);
  };

  // RECHARGE_PLANS_BASE
  const [tabTypes, setTabTypes] = useState([
    { id: "1", tabTitle: "Popular", tabContent: <></> },
    { id: "2", tabTitle: "Validity", tabContent: <></> },
    { id: "3", tabTitle: "Data Add On", tabContent: <></> },
    { id: "4", tabTitle: "Top Up", tabContent: <></> },
    { id: "5", tabTitle: "Roaming", tabContent: <></> }
  ]);
  // const tabTypes = [
  //   { id: "1", tabTitle: "Popular", tabContent: <></> },
  //   { id: "2", tabTitle: "Validity", tabContent: <></> },
  //   { id: "3", tabTitle: "Data Add On", tabContent: <></> },
  //   { id: "4", tabTitle: "Top Up", tabContent: <></> },
  //   { id: "5", tabTitle: "Roaming", tabContent: <></> },
  // ];

  const selectedTabTitle = tabTypes
    ?.filter((tab) => tab.id === visibleTab)
    ?.map((item) => item.tabTitle)
    ?.toString();

  React.useEffect(() => {
    const queryParams = {
      circleId: circleId,
      operatorId: operatorId,
      planTypeSearch: selectedTabTitle,
      page: 0,
      size: 100,
      sortAscending: true,
      sortingField: "planName",
    };
    const body = {
      url: `${GET_RECHARGE_PLANS}?${qs.stringify(queryParams)}`,
      token: authToken,
    };
    rechargePlansMutation(body);
  }, [rechargePlansMutation, circleId, operatorId, selectedTabTitle]);

  return (
    <PageWrapper title="Recharge">
      <div className="row my-4 pay-bills">
        <div className="col-md-3 col-12">
          <Widget
            step={step}
            changeStep={changeStep}
            selectedBiller={context?.state?.rechargeNumber}
          />
        </div>
        <div className="col-md-8 col-12">
          <div className="position_relative">
            <div className="widget-provider">
              <RechargePlans
                changeStep={changeStep}
                tabTypes={tabTypes}
                rechargePlansData={
                  fetchedRechargePlan &&
                  rechargePlansData &&
                  rechargePlansData?.content
                }
                visibleTab={visibleTab}
                setVisibleTab={setVisibleTab}
                setOperatorId = {setOperatorId}
                setCircleId = {setCircleId}
              />
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}
